import { configureStore } from '@reduxjs/toolkit'
import gamePromptReducer from './features/gamePromptSlice'
import gameIdeaReducer from './features/gameIdeaSlice'
import gameConfigReducer from './features/gameConfigSlice'
import gameCodeReducer from './features/gameCodeSlice'
import systemReducer from './features/systemSlice'
import contextReducer from './features/contextSlice'
import gameDetailsReducer from './features/gameDetailsSlice'
import gameDisplayReducer from './features/gameDisplaySlice'
import userReducer from './features/userSlice'
import imageReducer from './features/imageSlice'
import tutorialReducer from './features/tutorialSlice'
import undoRedoReducer from './features/undoRedoSlice'
import chatReducer from './features/chatSlice'
import projectReducer from './features/projectSlice'
import soundReducer from './features/soundSlice'
import immutableStateInvariantMiddleware from 'redux-immutable-state-invariant'
import stepperReducer from './features/stepperSlice'

const middleware = (getDefaultMiddleware: any) =>
  getDefaultMiddleware({
    serializableCheck: false,
  }).concat(
    // Add the immutable state invariant middleware in development mode
    process.env.NODE_ENV !== 'production'
      ? immutableStateInvariantMiddleware()
      : []
  )

export const store = configureStore({
  reducer: {
    gamePrompt: gamePromptReducer,
    gameIdea: gameIdeaReducer,
    gameConfig: gameConfigReducer,
    gameCode: gameCodeReducer,
    system: systemReducer,
    gameDetails: gameDetailsReducer,
    gameDisplay: gameDisplayReducer,
    user: userReducer,
    image: imageReducer,
    tutorial: tutorialReducer,
    undoRedo: undoRedoReducer,
    chat: chatReducer,
    context: contextReducer,
    project: projectReducer,
    sound: soundReducer,
    stepper: stepperReducer,
  },
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
